import React from 'react';
import {ChatEngine} from 'react-chat-engine';
import ChatFeed from './Components/ChatFeed';
import LoginForm from './Components/LoginForm';
import './App.css';

function App() {
  if(!localStorage.getItem('username'))
 {
    return (<LoginForm/>)
 }
  return (
   <ChatEngine
    height ="100vh"
    projectID ="cd860518-4f13-42f4-8648-f33db9919951"
    userName={localStorage.getItem('username')}
    userSecret={localStorage.getItem('password')}
    renderChatFeed ={(chatAppProps) => <ChatFeed  {... chatAppProps}/>}
   />
  
  );
}

export default App;